// extracted by mini-css-extract-plugin
export default {"root":"ExclusionGroupGraphic_root__snIh6","or":"ExclusionGroupGraphic_or__F0b7S","disabled":"ExclusionGroupGraphic_disabled__mvXd+"};